var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{staticClass:"app-back",on:{"click":function($event){$event.preventDefault();return _vm.back.apply(null, arguments)}}},[_c('b-icon',{attrs:{"icon":"arrow-left"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }